import {alias, createModelSchema, reference, custom} from "serializr";
import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {Schema} from "@/common/Schema";
import {MapKindModel} from "@/modules/redactor/models/map/MapKindModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class TriggerGeneric extends TriggerBase {

    constructor() {
        super(TriggerKind.GENERIC);
        this._level = 0;
        this._amount = 0;
        this._map = 0;
    }

    get level() {
        return this._level;
    }

    set level(value) {
        this._level = value;
    }

    get map() {
        return this._map;
    }

    set map(value) {
        this._map = value;
    }

    valid() {
        return super.valid();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerGeneric());
        } else if (target instanceof TriggerGeneric) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerGenericScope extends TriggerScope {
    static _values = [
        new TriggerGenericScope(1, "USE_MANA"),
        new TriggerGenericScope(2, "UNLOCK_LEVEL"),
        new TriggerGenericScope(3, "UNLOCK_REGION"),
        new TriggerGenericScope(4, "UNLOCK_REGION_NOW"),
        new TriggerGenericScope(5, "PASSED_SWAMP"),
        new TriggerGenericScope(6, "UNLOCK_REGION_TERRITORY"),
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerGenericScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerGenericScope());
        } else if (target instanceof TriggerGenericScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerGeneric, {
    _scope: alias("scope", TriggerGenericScope.schema()),
    _level: alias("level", Schema.primitive()),
    _map: alias("map_id", custom(
        v => {
          if (v == null) return null;
          if (typeof v === "number") {
            return v;
          }

          const key = v instanceof MapKindModel ? v.key : typeof v === "string" ? v : null;

          if (!key) return null;

          const found = RedactorUtils.getMapKindByKey(key);
          return found ? found.code : null;
        },
        raw => {
          if (raw == null) return null;
          if (raw instanceof MapKindModel) {
            return raw;
          }

          if (typeof raw === "number") {
            const list = RedactorUtils.getMapKinds();
            return list.find(mk => mk.code === raw) || null;
          }

          if (typeof raw === "string") {
            return RedactorUtils.getMapKindByKey(raw);
          }

          return null;
        }
      )
    )
});